import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

/**
 * Delete an image from an address.
 *
 * @param addressId - The ID of the address.
 * @param imageId - The ID of the image.
 * @param token - Authentication token.
 * @param t - Translation function.
 * @returns A promise that resolves to the API response.
 */
export async function deleteAddressImageAsync(
  addressId: number,
  imageId: number,
  token: string,
  t: (key: string) => string
): Promise<any> {

  if (!navigator.onLine) {
    toast.error(t("internetConnection"), { toastId: "offline-error" });
    return null;
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/address/DeleteAddressImageAsync?addressId=${addressId}&imageId=${imageId}`,
      {
        method: "DELETE",
        headers: {
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.text();

      throw new Error(
        `Error: ${response.status} ${response.statusText} - ${errorData}`
      );
    }

    // Some DELETE APIs return no content.
    if (response.status === 204) {
      return null;
    }

    const result = await response.json();
    return result;

  } catch (error) {
    throw error;
  }
}